import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pzbv7m48pw: FaireBrandEntity = {
  token: "b_pzbv7m48pw",
  type: "brand",
  name: "Little Daisy Closet",
  avatarUrl:
    "https://cdn.faire.com/fastly/6dc79d8d7e20b77cd5b767c16cf11a7c533e1ae1fdb15293f4e743f0f7fabfa7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c2f465201d520d9eaaff6d171b17ff5c5eae9de0dc5b20bfc701522e014e7d89.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6dc79d8d7e20b77cd5b767c16cf11a7c533e1ae1fdb15293f4e743f0f7fabfa7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c2f465201d520d9eaaff6d171b17ff5c5eae9de0dc5b20bfc701522e014e7d89.jpeg",
  location: "Diamond Bar, CA, USA",
  minimumOrderDollars: 109,
  rating: 4.7,
  reviewCount: 2278,
  isInsider: true,
  description:
    "🌼 Welcome to Little Daisy Closet, where fashion meets passion! 🌟\n\n👗 Discover daily new styles crafted with precision and care from our own production line.\n\n💖 We believe in empowering women to feel confident and stylish in every piece they wear.\n\n🌟 Elevate your wardrobe with our exclusive designs and embrace your unique style journey.\n\n🚚 Orders shipped from New York, USA, with expedited options from oversea factory directly available for urgent needs.\n\n📦 Average lead time: 1-3 business days. Average shipping time: 5-10 business days.\n\n🎨 We offer personalized woven labels and tags. If you're interested in this service, please contact us to learn more details.\n\n🌟 Your satisfaction is our priority. Contact us anytime for assistance with your order or shipping inquiries.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:19.573Z",
    importedBy: "entity-db-cli",
  },
};
